import ChartWidgetContainer from './ChartWidgetContainer';

export default ChartWidgetContainer;
